<template>
  <div
    class="form-container login-form"
  >
    <div>
      <h4>Log In</h4>
      <p>Already a member? Log in with your username and password.</p>
    </div>
    <form
      id="new_customer"
      class="simple_form second-account-form"
      novalidate="novalidate"
      action="/customers/sign_in"
      accept-charset="UTF-8"
      data-remote="true"
      method="post"
    >
      <input
        name="utf8"
        type="hidden"
        value="✓"
      >
      <div class="form-group">
        <input
          id="customer_email"
          v-validate="{required: true}"
          :placeholder="$t('form.email')"
          class="form-control"
          value=""
          type="email"
          name="customer[email]"
        >
        <div>
          <label
            v-show="errors.has('customer[email]')"
            class="error"
            for="customer_email"
          >
            Please enter a valid email
          </label>
        </div>

        <input
          id="customer_password"
          autocomplete="off"
          :placeholder="$t('form.password')"
          class="form-control password second-account-form-password"
          type="password"
          name="customer[password]"
          @keyup.enter="submit"
        >
        <div class="response" />
      </div>
      <div class="form-group submit">
        <input
          id="loginBtn"
          type="submit"
          name="commit"
          :value="loginBtnText"
          class="btn btn-primary btn-block login-btn"
          data-disable-with="submit"
        >
      </div>
    </form>
    <div class="forgot-password-link">
      <a href="/customers/password/new">{{ $t('forgotYourPassword') }}</a>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      loginBtnText: ''
    }
  },

  mounted() {
    this.submitText()
  },

  methods: {
    submit() {
      const passwordInput = document.getElementById('customer_password')
      const login = document.getElementById('loginBtn')
      passwordInput.addEventListener('keyup', function(e) {
        if (e.keyCode === 13) { login.click() }
      })
    },
    submitText(){
      let path = document.getElementById('gaPathOverride').dataset.url
      if(path == '/login') {
        this.loginBtnText = 'Log In'
      } else {
        this.loginBtnText = 'Log In & Checkout'
      }
    },
  }
}
</script>
